module.exports = __webpack_public_path__ + "afd90cb167442a306fdc420360f5c6f0.svg";